import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { mergeStyleSets, PrimaryButton, FontSizes, FontWeights } from '@fluentui/react';

import { getIconSvg } from 'utils/svg';
import { Announce } from './Announce';
import translationKeys from 'translationKeys';
import { useContext } from 'react';
import TranslationsContext from 'translations/TranslationsContext';

const styles = mergeStyleSets({
	root: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		flexGrow: 1
	},
	img: {
		width: '200px',
		height: '200px'
	},
	heading: {
		fontSize: FontSizes.size18,
		fontWeight: FontWeights.semibold
	},
	info: {
		maxWidth: '290px',
		textAlign: 'center',
		fontSize: FontSizes.size14,
		marginTop: 0
	}
});

export const PageNotFound = () => {
	const { t } = useContext(TranslationsContext)!;
	const navigate = useNavigate();

	const pageName = t(translationKeys.PageNotFound.PageName);

	return (
		<div className={styles.root}>
			<Announce message={pageName} />
			<img alt={t(translationKeys.PageNotFound.Img.AltText)} className={styles.img} src={getIconSvg('plug', 'images')} />
			<h1 className={styles.heading}>{pageName}</h1>
			<p className={styles.info}>{t(translationKeys.PageNotFound.Paragraph.First)}</p>
			<PrimaryButton allowDisabledFocus text={t(translationKeys.PageNotFound.Button.Text)} onClick={() => navigate('/')} />
		</div>
	);
};
